import { logo } from "@/lib/logo-dev";
import type { IntegrationCategoryId } from "@/lib/api/model";

/**
 * Presentation constants for the integrations catalog. The integration DATA
 * (cards + detail) is served by the backend (`useListIntegrationsAuthenticated`);
 * only the display helpers below stay frontend-side.
 */

export type Category = IntegrationCategoryId;

/** logo.dev image URL for an integration's brand domain (e.g. "ashbyhq.com"). */
export function logoUrl(domain: string) {
  return logo({ domain, size: 128, format: "png" }) ?? "";
}

/** Cards per page in the catalog grid. */
export const PER_PAGE = 8;

/**
 * Category icon paths, keyed by the backend category id. The labels/counts come
 * from the catalog response; only these icon assets are frontend constants.
 */
export const CATEGORY_ICONS: Record<Category, string> = {
  ats: "/icons/integrations/ats-icon.svg",
  crm: "/icons/integrations/crm-icon.svg",
};
